import React from 'react'

export default function BigCartel(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={14}
            height={18}
            fill="none"
            {...props}
        >
            <path
                fill="#fff"
                d="M6.755 9.352v-.667a1.335 1.335 0 0 1 .622-1.133l5.513-3.524a1.343 1.343 0 0 0 .615-1.133V0l-6.75 4.313L.005 0v9.113a6.518 6.518 0 0 0 2.91 5.684l3.84 2.453 3.84-2.453a6.519 6.519 0 0 0 2.91-5.684V5.04l-6.75 4.312Z"
            />
        </svg>
    )
}
